/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_InboundInputs */

const cs_enum_inbound = /** @type {(inputs: Enum_InboundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Příchozí`)
};

const en_enum_inbound = /** @type {(inputs: Enum_InboundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbound`)
};

/**
* | output |
* | --- |
* | "Inbound" |
*
* @param {Enum_InboundInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_inbound = /** @type {((inputs?: Enum_InboundInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_InboundInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_inbound(inputs)
	return cs_enum_inbound(inputs)
});